import { Button, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Select, Spinner, useDisclosure, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDoorData } from './context/DoorContext';

function CreateEmployeeModal({onlyCreate, isOpen, onOpen, onClose, editMode, editEmployee, setEditEmployee}) {

    const { getAllEmployees, loading, axiosJWT, allCardGroups, getAllCardGroups, loadDataFromEmaitinimas} = useDoorData()
    const [pickedGroupID, setPickedGroupID] = useState(allCardGroups.filter((cardgroup) => 
      cardgroup.name === editEmployee.group
    )[0]?.id || null);

    const { register, setValue, handleSubmit, formState: { isSubmitting }, reset } = useForm();

    const toast = useToast()
   
  
  useEffect(() => {
    if(!loadDataFromEmaitinimas){
      getAllCardGroups();
    }

  },[])

    useEffect(() => {
        setValue('name', editEmployee.name)
        setValue('surname', editEmployee.surname)
        setValue('cardno', editEmployee.cardno)
        setValue('group', pickedGroupID)
        
      }, [editEmployee])
    
      
      const onSubmit = async data => {

          console.log(data);
          try {
            const res = await axiosJWT.put("/api/employee/create", { name: data.name, surname: data.surname, cardno: data.cardno, group: pickedGroupID })
            if (res) {
              toast({
                title: '👋 Kortelė, ' + data.name + ' sukurta!',
                position: 'bottom',
                status: 'success',
                isClosable: true,
                duration: 4000
              })
              
             

             getAllEmployees();

              onClose();
              reset();
             
              console.log(data);
            }
    
          } catch (err) {
            console.log(err.response.data);
            toast({
              title: err.response.data,
              position: 'bottom',
              status: 'error',
              isClosable: true,
              duration: 4000
            })
          
        }
    
      };
      
    
      const onEdit = async data => {
        
        

          try {
            const res = await axiosJWT.put("/api/employee/edit", { id: editEmployee.id, name: data.name, surname: data.surname, cardno: data.cardno, group: pickedGroupID })
            if (res) {
              toast({
                title: '👋 Kortelė, ' + data.name + ' redaguota!',
                position: 'bottom',
                status: 'success',
                isClosable: true,
                duration: 4000
              })
              
              onClose();
              getAllEmployees();
              setEditEmployee([])
              reset();
    
            }
    
          } catch (err) {
            console.log(err.response.data);
            toast({
              title: err.response.data,
              position: 'bottom',
              status: 'error',
              isClosable: true,
              duration: 4000
            })
            onClose();
            setEditEmployee([])
          
        }
    
    
    
      };





  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>

          <ModalHeader>{!editMode ? 'Pridėti kortelę' : 'Redaguoti kortelę'}</ModalHeader>

          <ModalCloseButton />
          <ModalBody m={'1rem'}>
            {loading ?
              <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='green.500'
                size='xl'
              />
              :
              <form onSubmit={!editMode ? handleSubmit(onSubmit) : handleSubmit(onEdit)}>
                <FormControl maxW={'30rem'} >
                  <FormLabel>Vardas</FormLabel>
                  <Input autoComplete="off" mb={'1rem'} id='name' {...register("name", { required: true })} name='name' type='text' />
                  <FormLabel>Pavardė</FormLabel>
                  <Input autoComplete="off" mb={'1rem'} id='surname' {...register("surname", { required: true })} name='surname' type='text' />
                  
                  <FormLabel>Kortelės grupė</FormLabel>
                  <Select placeholder='Pasirinkite grupę' {...register("group")} onChange={(e) => setPickedGroupID(e.target.value || null ) }>
                  {
                        allCardGroups.map((cardgroup, index) => {
                                return <option key={index} value={cardgroup.id}>{cardgroup.name}</option>
                           
                        })
                    }

                  </Select>
                  
                  {!onlyCreate && <><FormLabel>Kortelės numeris</FormLabel>
                  <Input autoComplete="off" mb={'1rem'} id='cardno' {...register("cardno")} name='cardno' type='text' /> </>}
                  <Button mt={'1rem'} width={'100%'} colorScheme={'green'} isLoading={isSubmitting} type={'submit'} >{!editMode ? 'Pridėti kortelę' : 'Redaguoti kortelę'}</Button>
                </FormControl>
              </form>

            }




          </ModalBody>
        </ModalContent>
      </Modal>
  )
}

export default CreateEmployeeModal